import React from "react";
import withMotion from "../../../../Utils/withMotion";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Blog.scss";

//Utils
import { mapBlogs } from "../../Pagination/utils";

//Images
import img001 from "../../images/firePit/blog-fire-pit-001.jpg";
import img002 from "../../images/firePit/blog-fire-pit-002.jpg";
import img003 from "../../images/firePit/blog-fire-pit-003.jpg";
import img004 from "../../images/firePit/blog-fire-pit-004.jpg";

// SEO
import SEO from "../../../../SEO/index.js";
import StructuredData from "../../../../SEO/structuredData";
import { ViewPavers } from "../../../../CTA/CTA";

export const FirePitData = {
  title:
    "Everything You Need to Know About Building Fire Pits in Your Southern California Backyard",
  image: img001,
  destination:
    "/blog/everything-need-know-building-fire-pits-southern-california-backyard",
  date: "September 7, 2016",
  categories: ["blog", "patios"],
};

const FirePit = () => {
  const blog = [FirePitData];

  return (
    <>
      <SEO
        title="Fire Pit Rules and Regulations in Southern California"
        description="If you want to enhance your outdoor living experience by adding a fire pit, here are a few things you need to know about building fire pits in Southern California."
        profileURL={
          "https://www.pacificpavingstone.com/blog/everything-need-know-building-fire-pits-southern-california-backyard"
        }
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "BlogPosting",
          author: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
          URL: "https://www.pacificpavingstone.com/blog/everything-need-know-building-fire-pits-southern-california-backyard",
          headline: "Fire Pit Rules and Regulations in Southern California",
          description:
            "If you want to enhance your outdoor living experience by adding a fire pit, here are a few things you need to know about building fire pits in Southern California.",
          image: {
            "@type": "ImageObject",
            url: "https://www.pacificpavingstone.com/static/media/blog-fire-pit-001.d004a692.jpg",
          },
          datePublished: "2016-09-07",
          publisher: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
        }}
      />
      <div className="container-fluid page-blog">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-6">
            {mapBlogs(1, blog, true)}
            <p>
              There is something ancient and primal about gathering around a
              fire. Human beings have always been drawn to fire – drawn to the
              warmth, to stories shared and memories made in front of flickering
              flames as the day draws to a close.
              <br />
              <br />
              It’s no surprise that building fire pits in Southern California is
              a regularly considered outdoor improvement. A fire feature can
              make your backyard comfortable for entertaining year round, and
              with creative designs and building materials, the possibilities
              are nearly limitless.
              <br />
              <br />
              If you’ve been wanting to enhance your outdoor living experience
              by adding a fire pit to your landscape, here are a few things you
              need to know about building fire pits in Southern California.
            </p>
            <h4>Are fire pits legal in Southern California?</h4>
            <img src={img002} alt="Feature" />
            <p>
              With air quality concerns and even periodic burn bans in effect in
              portions of the state, some homeowners ask whether or not fire
              pits are even legal in Southern California?
              <br />
              <br />
              The short answer is, yes! Fire pits are legal in most cities,
              however each city in Southern California has different ordinances
              for building fire pits, and it’s good to check the laws for your
              city before building.
              <br />
              <br />
              While wood burning fire pits provide a great ambiance as well as
              the pleasant aroma of burning wood, propane and natural gas fire
              pits are also a good option. In fact propane and natural gas are a
              more environmental alternative to wood burning fire pits. They
              burn cleaner and therefore aren’t affected by the burn bans that
              sometimes impact Southern California.
              <br />
              <br />A knowledgeable designer and a landscape company will
              research fire pit ordinances Southern California municipalities
              require. They will be happy to walk you through the process of
              building a great fire pit at your home that meets all the
              requirement in your city, without any of the headaches.
            </p>
            <h4>Size and Placement of Fire Pits</h4>
            <p>
              There are several major considerations that factor into designing
              a fire pit that will be both versatile and functional. No two fire
              pits need to be exactly the same, but there are some common
              questions that can help you decide what sort of fire pit you would
              like to include in your backyard getaway.
            </p>
            <h4>How close can a fire pit be to my house?</h4>
            <p>
              When building fire pits in Southern California, remember that most
              communities require a minimum of at least a 10-foot distance from
              your house and from the neighbor’s property, but some instances
              the distance must be 30 feet or more. Each city has different laws
              about where fire pits can be placed, so checking your local
              ordinances is an important first step.
            </p>
            <h4>What size fire pit do I need?</h4>
            <p>
              The size of your fire pit should be determined by the size and
              scale of your outdoor living space as well as the entertaining
              needs you have for the space. Fire pit builders in Southern
              California may choose a smaller pit only three feet in diameter
              for a simple patio, with large fire features exceeding 6 feet in
              width or even more in a massive outdoor setting.
            </p>
            <h4>How deep should my fire pit be?</h4>
            <p>
              Fire pits can be dug into the ground, but more typically modern
              fire pits are actually built above ground to a height between
              12-14 inches. However, if you want to be able to use the edge of
              the fire pit as additional seating when it’s not in use, a height
              of 18-20 inches will be more comfortable.
            </p>
            <img src={img003} alt="Feature" />
            <h4>Which is Better? Stone Fire Pits or Brick Fire Pits?</h4>
            <p>
              The two most common materials for custom designed fire pits are
              stone and decorative concrete bricks. Fire pit builders in
              Southern California can complement the look of your home and your
              landscape with materials that accent the features of your home.
              <br />
              <br />
              Concrete bricks come in all shapes and colors, that can often be
              matched with existing patios or retaining walls. Decorative
              concrete bricks are often more temperature resistant than stone
              when building a fire pit, something that is important especially
              in wood burning fire pits.
              <br />
              <br />
              Concrete brick fire pits are normally easier and more
              cost-effective to install, but each landscape design has different
              needs, and stone masonry fire pits can sometimes be a good option
              as well.
            </p>
            <h4>When You Want a BIG Fire Pit or Feature</h4>
            <p>
              The most spectacular fire pits can be the focal point of your
              whole landscape, and bring it that “wow” factor you’ve been
              looking for. For homeowners who really want an eye catching fire
              pit, it’s time to think BIG! Building fire pits in Southern
              California can often lead to larger fire pits or similar “fire
              features” can be 6 feet or more, and aren’t limited to a circular
              shape.
              <br />
              <br />
              Combining fire pits with water features like pools, fountains, and
              waterfalls, creates a sizzling contrast with flames reflecting off
              the surface of the water to create an otherworldly glow that
              enhances the evening appeal of a water feature. Other options
              include designing built in seating around the fire pit to
              accommodate entertaining family and friends.
              <br />
              <br />
              Creative building materials can be eye catching as well. Granite,
              Marble, and Slate slabs can heighten the sense of luxury and old
              world charm of a dazzling fire feature. Inside the fire pit
              itself, rugged lava rocks or bright glass pebbles can add another
              layer of visual intrigue.
            </p>
            <img src={img004} alt="Feature" />
            <h4>
              Trusted Professional Fire Pit Builders in Southern California
            </h4>
            <p>
              Having a trusted landscape company like Pacific Outdoor Living
              involved in both the design and construction of your fire pit can
              be a big advantage to you as the homeowner.
              <br />
              <br />
              Our experienced and knowledgeable designers will ensure that fire
              pits ordinances in Southern California municipalities are followed
              to spare you of future problems. A team of in-house installers
              will follow detailed plans to make sure your fire pit is built for
              long lasting quality and enjoyment.
              <br />
              <br />
              Whether it’s a small area or part of a large, encompassing design
              for a backyard retreat, a fire pit can add that signature touch to
              your home that provides warmth and relaxation for many years to
              come.
            </p>
            <ViewPavers/>
          </div>
          <Sidebar />
        </div>
      </div>
    </>
  );
};

export default withMotion(FirePit);
